__turbopack_context__.v({
  "component": "bpWkGG_component",
  "error": "bpWkGG_error",
  "fadeIn": "bpWkGG_fadeIn",
  "fadeOut": "bpWkGG_fadeOut",
  "hide": "bpWkGG_hide",
  "warning": "bpWkGG_warning",
});
